import * as React from "react";
const DoubleChevronLeft = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M11.0005,4 L11.7075,4.707 L4.4145,12.001 L11.7075,19.295 L11.0005,20.002 L3.0005,12.001 L11.0005,4 Z M19.293,3.998 L20,4.705 L12.707,11.999 L20,19.293 L19.293,20 L11.293,11.999 L19.293,3.998 Z" }));
DoubleChevronLeft.displayName = "DoubleChevronLeft";
var DoubleChevronLeft_default = DoubleChevronLeft;
export {
  DoubleChevronLeft_default as default
};
